import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { update } from './services/upload-files.service';

export default function Changepassword() {
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);
        console.log(errors);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                setLoading(true);
                // Only send email and new password in the API request
                const email = localStorage.getItem('email');
                const { newpassword } = formData;
                const response = await update({ email, password: newpassword }, `change-password`);
                const res = response.res;
                if (res && res.affectedRows !== undefined && res.affectedRows > 0) {
                    setValidationErrors({ success: 'Password Changed Successfully' });
                } else {
                    setValidationErrors({ err: 'Failed to Change Password. Please Try Again.' });
                }
            } catch (error) {
                setValidationErrors({ err: 'An Error Occurred. Please Try Again Later.' });
            }
            setLoading(false);
        }
    };

    const validateFormFields = (formData) => {
        const errors = {};
        if (!formData.newpassword || formData.newpassword.trim() === '') {
            errors.newpassword = 'Please Enter a New Password';
        }
        if (!formData.confirmpassword || formData.confirmpassword !== formData.newpassword) {
            errors.confirmpassword = 'Passwords Do Not Match';
        }
        return errors;
    };

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Change Password</h1>
            </div>
            <div className='row'>
                <div className='col-4'>
                    <div className='editprofile'>
                        <h4>User Password</h4>
                        <hr />
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="newpassword">
                                <Form.Label>New Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="newpassword"
                                    value={formData.newpassword || ''}
                                    onChange={handleInputChange}
                                />
                                {validationErrors.newpassword && <div className="error login-error">{validationErrors.newpassword}</div>}
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="confirmpassword">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="confirmpassword"
                                    value={formData.confirmpassword || ''}
                                    onChange={handleInputChange}
                                />
                                {validationErrors.confirmpassword && <div className="error login-error">{validationErrors.confirmpassword}</div>}
                            </Form.Group>
                            <button class="btn btn-primary btn-add mb-3" variant="primary" type='submit' disabled={loading}>
                                {loading ? 'Saving...' : 'Save'}
                            </button>
                        </Form>
                        {validationErrors.err && <div className="error login-error">{validationErrors.err}</div>}
                        {validationErrors.success && <div className="success">{validationErrors.success}</div>}
                    </div>
                </div>
            </div>
        </main>
    );
}
